{
  "button_text": "Edit",
  "title": "Formula",
  "categories": "Categories",
  "who": "Who",
  "feeds": "Feeds",
  "labels": "Labels",
  "update": "Update",
  "success_toast": "✨ Snippet updated!",
  "error_toast": "Error updating snippet"
}
